;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ExploreTopicLabelEnum, ExploreTopicRouteEnum } from "@/lib/constants";

type LinkWithCondition<T> = T & { condition?: boolean };

const visibleLinks = <T>(links: LinkWithCondition<T>[]) => links.filter(link => link.condition !== false);
interface ContentNavConditionalTypes {
  isSVP: boolean;
  isLocalized: boolean;
  isPassportEnabled: boolean;
  isAccessibilityExploreHubEnabled: boolean;
}

const contentNavLinks = (conditions: ContentNavConditionalTypes) => {
  const links = [
    { label: 'My Station', href: '/', condition: conditions.isSVP },
    { label: 'Featured', href: '/', condition: !conditions.isSVP},
    { label: ExploreTopicLabelEnum.Drama, href: ExploreTopicRouteEnum.Drama },
    { label: ExploreTopicLabelEnum.Mystery, href: ExploreTopicRouteEnum.Mystery },
    { label: ExploreTopicLabelEnum.DocumentariesAndIndieFilms, href: ExploreTopicRouteEnum.DocumentariesAndIndieFilms },
    { label: ExploreTopicLabelEnum.History, href: ExploreTopicRouteEnum.History },
    { label: ExploreTopicLabelEnum.NewsAndPublicAffairs, href: ExploreTopicRouteEnum.NewsAndPublicAffairs },
    { label: ExploreTopicLabelEnum.ScienceAndNature, href: ExploreTopicRouteEnum.ScienceAndNature },
    { label: ExploreTopicLabelEnum.Passport, href: ExploreTopicRouteEnum.Passport, include_passport_icon: true, condition: conditions.isLocalized && conditions.isPassportEnabled },
    { label: ExploreTopicLabelEnum.Arts, href: ExploreTopicRouteEnum.Arts},
    { label: ExploreTopicLabelEnum.Food, href: ExploreTopicRouteEnum.Food },
    { label: ExploreTopicLabelEnum.Culture, href: ExploreTopicRouteEnum.Culture },
    { label: ExploreTopicLabelEnum.HomeAndHowTo, href: ExploreTopicRouteEnum.HomeAndHowTo},
    { label: ExploreTopicLabelEnum.HenryLouisGatesJr, href: ExploreTopicRouteEnum.HenryLouisGatesJr},
    { label: ExploreTopicLabelEnum.AmericaAt250, href: ExploreTopicRouteEnum.AmericaAt250},
    { label: ExploreTopicLabelEnum.Accessibility, href: ExploreTopicRouteEnum.Accessibility, condition: conditions.isAccessibilityExploreHubEnabled },
  ]

  return visibleLinks(links);
}

type MobileMenuGenreConditionalTypes = Omit<ContentNavConditionalTypes, 'isSVP'>

const mobileMenuGenreLinks = (conditions: MobileMenuGenreConditionalTypes) => {
  const links = [
    { label: ExploreTopicLabelEnum.Passport, href: ExploreTopicRouteEnum.Passport, include_passport_icon: true, condition: conditions.isLocalized && conditions.isPassportEnabled },
    { label: ExploreTopicLabelEnum.Arts, href: ExploreTopicRouteEnum.Arts},
    { label: ExploreTopicLabelEnum.Culture, href: ExploreTopicRouteEnum.Culture },
    { label: ExploreTopicLabelEnum.DocumentariesAndIndieFilms, href: ExploreTopicRouteEnum.DocumentariesAndIndieFilms },
    { label: ExploreTopicLabelEnum.Drama, href: ExploreTopicRouteEnum.Drama },
    { label: ExploreTopicLabelEnum.HenryLouisGatesJr, href: ExploreTopicRouteEnum.HenryLouisGatesJr},
    { label: ExploreTopicLabelEnum.AmericaAt250, href: ExploreTopicRouteEnum.AmericaAt250},
    { label: ExploreTopicLabelEnum.Food, href: ExploreTopicRouteEnum.Food },
    { label: ExploreTopicLabelEnum.History, href: ExploreTopicRouteEnum.History },
    { label: ExploreTopicLabelEnum.HomeAndHowTo, href: ExploreTopicRouteEnum.HomeAndHowTo},
    { label: ExploreTopicLabelEnum.Mystery, href: ExploreTopicRouteEnum.Mystery },
    { label: ExploreTopicLabelEnum.NewsAndPublicAffairs, href: ExploreTopicRouteEnum.NewsAndPublicAffairs },
    { label: ExploreTopicLabelEnum.ScienceAndNature, href: ExploreTopicRouteEnum.ScienceAndNature },
    { label: ExploreTopicLabelEnum.Accessibility, href: ExploreTopicRouteEnum.Accessibility, condition: conditions.isAccessibilityExploreHubEnabled },
  ]

  return visibleLinks(links);
}

export { contentNavLinks, mobileMenuGenreLinks };
